import React, { useState, useEffect } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import muiTheme from './muiTheme';

/**
 * ThemeProvider component that provides Material UI theming to the application
 * while maintaining compatibility with Tailwind CSS
 */
const ThemeProvider = ({ children }) => {
  const [themeLoaded, setThemeLoaded] = useState(false);
  
  useEffect(() => {
    // Mark the theme as loaded after component mounts
    setThemeLoaded(true);
  }, []);
  
  return (
    <MuiThemeProvider theme={muiTheme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};

export default ThemeProvider; 